import RegisterDialog from './RegisterDialog';

export default { 
  name: "register", 
  component: RegisterDialog, 
  fullScreen: false
};